import compact from 'lodash/compact';
import {createStore, applyMiddleware, combineReducers} from 'redux';
import thunkMiddleware from 'redux-thunk';
import {createLogger} from 'redux-logger';
import {composeWithDevTools} from 'redux-devtools-extension';
import {createReduxLocationActions} from 'redux-location-state';
import {mapLocationToState} from './location';
import api from './api';

const cleanDirtyStateMiddleware = (store) => (next) => (action) => {
  next(action);
  if (action.payload && action.payload.state && action.payload.state.dirty == true){
    delete action.payload.state.dirty
  }
};

export default function createAppStore(reducers, history, location) {
  const loggerMiddleware = createLogger({collapsed: true});
  const {locationMiddleware, reducersWithLocation} = createReduxLocationActions(
    location, 
    mapLocationToState, 
    history, 
    combineReducers(Object.assign({}, reducers, {
      [api.reducerPath]: api.reducer
    }))
  );

  let middleware = compact([
    thunkMiddleware,
    cleanDirtyStateMiddleware,
    locationMiddleware,
    api.middleware,
  ]);
  
  if (process.env.NODE_ENV !== 'production') {
    middleware = composeWithDevTools(applyMiddleware(...middleware))
  }

  if (process.env.NODE_ENV === 'production') {
    middleware = applyMiddleware(...middleware)
  }
  return createStore(reducersWithLocation, middleware)
}
